import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const entraProvider = new OAuthProvider(import.meta.env.VITE_FIREBASE_AUTH_PROVIDER_ID);
entraProvider.setCustomParameters({ prompt: "select_account" });

const SESSION_KEYS = ["Usuario", "emailUsuario", "fotoUsuario"];

const logout = async () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  await signOut(auth);
};

export { auth, entraProvider, logout };
